import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M244.5,112.2c-1.4-6.6-5.2-12.8-9.3-18.3,0,0-13.8-33.5-32.2-44-18.3-10.5-71.5-16.5-71.5-16.5-12.7-2.2-46.2,4.7-56.4,7.8-20.4,4.2-33.7,19.8-44.2,36.7-15.8,25.6-23,55-19.2,83.9,2.5-1.5,5-3.1,7.5-4.7,4-2.7,7.2-5.8,10.2-9.5l16.9-20.9c7.6-9.4,15.5-18.1,24.1-26.5,1.4-1.4,1.6-2.7,1.1-4.6l-3.4-13.9c-.5-2.1-.7-4.2-.5-6.4s1-1.5,1.9-1.3l22.9,7c1,.3,2-.4,2-1.4l.5-14.7c-.2-9.8,4.6-1.6,13.8,7.6s5,4.7,10.8,8.1c11.2.2,28.6,2.3,36.9,9.4l9.1,7.7c6.8,5.8,13.7,11,22,14.3,15.4,6,24.8,1.2,31.2,1.9,1,.1,2.2,2.5,2,3.6l-1.7,12.8c-.4,3.2-.5,6.3-.4,9.5s-2.2,5.1-5,5.1h-2.6c-1.5,0-2.9.6-3.8,1.7-10.8,12.7-24.9,21.8-41.1,25.4l-13,11.1c-10.4,8.9-18.5,20.1-23.9,32.8l-2.1,7.5-4,8.3c18.1.4,39.2-.2,54.5-4.2,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.3,4.6-21.1,5.6-31.8.6-6.7,1.6-13.5.2-20.1Z"
    />
    <path
      className="cls-1"
      d="M82.3,92.2l-6-4.7c-2.2-1.7-3.4-4.4-3.2-7.2s0,0,0,0c0-.7.8-1.2,1.5-1l18.4,5.6s-2.1,5-10.7,7.3Z"
    />
    <path
      className="cls-1"
      d="M114.7,80.6c-3.3-2-4.8-3.3-6.2-4.6-5.3-5.2-8-9.9-7.9-4.3l-.3,8.4s12.3,2.4,14.4.6Z"
    />
    <path
      className="cls-1"
      d="M148.9,114.3c3.2.9,3.4,4.2,5.9,5.4,1.1-2.9.2-5-1.2-7.2-1.6-2.4-4.8-3.5-7.6-2.6-4.1,1.3-6.6,6.7-4.4,9.9l3.1-4c.8-1,3.2-1.8,4.3-1.5Z"
    />
  </svg>
);
export default SVGComponent;
